export default "__VITE_ASSET__DUkM5XOe__"